export default "__VITE_ASSET__sz_6yKsX__"